export default function(data) {
    let items = data.data.items;
    let source = data.data.source;
    items = items.map(item=>({...item, source, id: item.family}));
    return {
        data: {
            data: items
        }
    };
}